import React from 'react'
import { DialogOverlay, Paragraph, DialogOverlayFooter, DialogOverlayActions, Button } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'

export default function JoinGroupErrorDialog({ errorMessage, overlay }) {
  const [t] = useTranslation()
  return (
    <DialogOverlay title={t('common-ui:error.label')} {...overlay}>
      <Paragraph>{errorMessage}</Paragraph>

      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button data-testid="ok-button" emphasis="high" onClick={overlay.close}>
            {t('common-ui:ok.action')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
